export enum PeppolStatus {
  Unknown = 0,
  Queued = 10,
  Sending = 11,
  Sent = 20,
  Delivered = 21,
  Acknowledged = 22,
  Accepted = 23,
  ConditionallyAccepted = 30,
  UnderQuery = 31,
  Rejected = 40,
  NotDelivered = 41,
  Error = 42,
  Skipped = 43,
  Received = 50,
  NotApplicable = 99,
}
